import { isEqual } from '../utilities/isEqual.js';
import { vec3 } from 'gl-matrix';
const ORTHOGONAL_TEST_VALUE = 0.999;
export function updatePlaneRestriction(points, reference, viewRefSpecifier = {}) {
    if (!points?.length || !reference.FrameOfReferenceUID) {
        return;
    }
    reference.planeRestriction ||= {
        FrameOfReferenceUID: reference.FrameOfReferenceUID,
        point: points[0],
        inPlaneVector1: null,
        inPlaneVector2: null,
    };
    const { planeRestriction } = reference;
    const n = points.length;
    updateReferencePoint(reference, points[0]);
    if (n === 1) {
        planeRestriction.inPlaneVector1 = null;
        planeRestriction.inPlaneVector2 = null;
        return planeRestriction;
    }
    if (n === 2) {
        const between = vec3.sub(vec3.create(), points[0], points[1]);
        vec3.normalize(between, between);
        planeRestriction.inPlaneVector1 = between;
        planeRestriction.inPlaneVector2 = null;
        return planeRestriction;
    }
    if (planeRestriction.inPlaneVector1 &&
        planeRestriction.inPlaneVector2 &&
        !viewRefSpecifier.forceInPlaneVectors) {
        return planeRestriction;
    }
    const v1 = vec3.sub(vec3.create(), points[0], points[Math.floor(n / 2)]);
    vec3.normalize(v1, v1);
    planeRestriction.inPlaneVector1 = v1;
    const candidate = vec3.create();
    let bestVector = null;
    let bestCollinearity = ORTHOGONAL_TEST_VALUE;
    for (let i = Math.floor(n / 3); i < n; i++) {
        vec3.sub(candidate, points[i], points[0]);
        const length = vec3.length(candidate);
        if (isEqual(length, 0)) {
            continue;
        }
        const collinearity = Math.abs(vec3.dot(candidate, planeRestriction.inPlaneVector1)) / length;
        if (collinearity < bestCollinearity) {
            bestCollinearity = collinearity;
            bestVector = vec3.scale(vec3.create(), candidate, 1 / length);
        }
    }
    if (bestVector) {
        planeRestriction.inPlaneVector2 = bestVector;
    }
    return planeRestriction;
}
function updateReferencePoint(reference, point) {
    const { planeRestriction, cameraFocalPoint, viewPlaneNormal } = reference;
    if (isEqual(planeRestriction.point, point)) {
        return;
    }
    planeRestriction.point = point;
    if (!cameraFocalPoint || !viewPlaneNormal) {
        return;
    }
    const focalToPoint = vec3.sub(vec3.create(), point, cameraFocalPoint);
    const depth = vec3.dot(focalToPoint, viewPlaneNormal);
    reference.cameraFocalPoint = (vec3.scaleAndAdd(vec3.create(), cameraFocalPoint, viewPlaneNormal, depth));
}
